import React, { useEffect, useState, useMemo } from "react";
import {
  emptyPaginationObj,
  LOADER_STATUS,
  SERVICE_SUPPORT_LIMIT,
} from "../../../../Constants/constant";
import { gethoursAndMins, getPaginationObj } from "../../../../Utils/utils";
import CircularLoader from "../../../../components/common/CircularLoader/CircularLoader";
import PaginationComponent from "../../../../components/common/Pagination/index";
import TableHeader from "../../../../components/common/Table/TableHeader";
import { BiPencil } from "react-icons/bi";

const ServiceSupportTable = (props) => {
  const {
    participant,
    fetchLoader,
    removeLoader = false,
    funding,
    getServiceSupportList,
    serviceSupportBudgets,
    setServiceSupportItem,
    // removeServiceCategory,
  } = props;
  const [renderLoading, setRenderLoading] = useState(LOADER_STATUS.NA);
  const [paginationObj, setPaginationObj] = useState(
    serviceSupportBudgets
      ? getPaginationObj(serviceSupportBudgets)
      : emptyPaginationObj
  );
  const [selectedId, setSelectedId] = useState(null);

  //   useEffect(() => {
  //     if (selectedId && !removeLoader) {
  //       setSelectedId(null);
  //     }
  //   }, [removeLoader]);

  useEffect(() => {
    if (serviceSupportBudgets) {
      setPaginationObj({
        ...getPaginationObj(serviceSupportBudgets),
      });
    }
  }, [serviceSupportBudgets]);

  useEffect(() => {
    if (
      !serviceSupportBudgets ||
      (serviceSupportBudgets &&
        Object.keys(serviceSupportBudgets).length > 0 &&
        serviceSupportBudgets.hasOwnProperty("data") &&
        serviceSupportBudgets.data.length === 0)
    ) {
      fetchServiceCategory({ page: paginationObj.page });
    }
  }, []);

  useEffect(() => {
    if (
      serviceSupportBudgets &&
      serviceSupportBudgets.current_page !== paginationObj.page
    ) {
      fetchServiceCategory({ page: paginationObj.page }).then();
    }
  }, [paginationObj.page]);

  const serviceSupportBudgetToMap = useMemo(() => {
    if (serviceSupportBudgets) {
      return serviceSupportBudgets.data;
    }
    return [];
  }, [serviceSupportBudgets]);

  const fetchServiceCategory = async (filters) => {
    if (!filters) {
      Object.assign((filters = {}), {
        page: paginationObj.page,
      });
    }
    Object.assign(filters, { per_page: SERVICE_SUPPORT_LIMIT });
    Object.assign(filters, {
      pt_id: participant.uuid || 1,
      funding_id: funding.id || 1,
      funding_reference_id: funding.contract_id,
    });
    if (renderLoading === LOADER_STATUS.NA) {
      setRenderLoading(LOADER_STATUS.PENDING);
    }
    getServiceSupportList(filters);
  };

  const handleDelete = (serviceCategoryId) => {
    setSelectedId(serviceCategoryId);
    // removeServiceCategory({ id: serviceCategoryId });
  };

  return (
    <>
      <div className='flex flex-col'>
        <div className='overflow-x-auto custom-scroll border'>
          <div className='min-w-[1200px]'>
            <table className='min-w-full divide-y divide-gray-300 table-fixed capitalize'>
              <thead className='bg-gray-50 capitalize'>
                <tr>
                  <TableHeader
                    isSort={false}
                    sortName='support_item_name'
                    label={"Support Item"}
                    cssClass='text-start min-w-[180px] px-4 py-2 text-xs sm:text-sm'
                  />
                  <TableHeader
                    isSort={false}
                    sortName='support_item_number'
                    label={"Support Item Number"}
                    cssClass='text-start min-w-[140px] px-4 py-2 text-xs sm:text-sm hidden md:table-cell'
                  />
                  <TableHeader
                    isSort={false}
                    sortName='unit'
                    label={"Unit"}
                    cssClass='text-center min-w-[60px] px-4 py-2 text-xs sm:text-sm hidden md:table-cell'
                  />
                  <TableHeader
                    isSort={false}
                    sortName='quantity'
                    label={"Total Quantity"}
                    cssClass='text-center min-w-[110px] px-4 py-2 text-xs sm:text-sm'
                  />
                  <TableHeader
                    isSort={false}
                    sortName='total_budget_amount'
                    label={"Total Funding"}
                    cssClass='text-center min-w-[110px] px-4 py-2 text-xs sm:text-sm hidden lg:table-cell'
                  />
                  <TableHeader
                    isSort={false}
                    sortName='delivered_amount'
                    label={"Delivered Amount"}
                    cssClass='text-center min-w-[120px] px-4 py-2 text-xs sm:text-sm hidden lg:table-cell'
                  />
                  <TableHeader
                    isSort={false}
                    sortName='delivered_quantity'
                    label={"Delivered Quantity"}
                    cssClass='text-center min-w-[120px] px-4 py-2 text-xs sm:text-sm hidden xl:table-cell'
                    title="This column displays the quantity delivered for each line item."
                  />
                  <TableHeader
                    isSort={false}
                    sortName='remain_quantity'
                    label={"Remaining Quantity"}
                    cssClass='text-center min-w-[120px] px-4 py-2 text-xs sm:text-sm hidden xl:table-cell'
                  />
                  <TableHeader
                    isSort={false}
                    sortName='remain_amount'
                    label={"Total Remaining"}
                    cssClass='text-center min-w-[120px] px-4 py-2 text-xs sm:text-sm'
                  />
                  <TableHeader
                    isSort={false}
                    sortName='Actions'
                    label={"Actions"}
                    cssClass='text-center min-w-[60px] px-2 py-2 text-xs sm:text-sm'
                  />
                </tr>
              </thead>
              <tbody className='divide-y divide-gray-200 bg-white'>
                {fetchLoader ? (
                  <tr>
                    <td colSpan={10} className='bg-gray-50 py-2'>
                      <CircularLoader
                        classes='flex justify-center items-center'
                        classloader='loader-l'
                      />
                    </td>
                  </tr>
                ) : serviceSupportBudgetToMap &&
                  serviceSupportBudgetToMap.length > 0 ? (
                  serviceSupportBudgetToMap.map((fund, index) => (
                    <tr key={index} className='text-left hover:bg-blue-50'>
                      <td className='px-4 py-4 text-sm text-gray-500'>
                        <div
                          title={fund?.price_catalog?.support_item_name}
                          className='text-gray-500'
                        >
                          {fund?.price_catalog?.support_item_name}
                        </div>
                        {fund?.external_sp && (
                          <div className='text-gray-800 font-bold capitalize'>
                            {fund?.external_sp?.name}
                          </div>
                        )}
                      </td>
                      <td className='px-4 py-4 text-sm text-gray-500 hidden md:table-cell'>
                        <div
                          title={fund?.price_catalog?.support_item_number}
                          className='text-gray-500'
                        >
                          {fund?.price_catalog?.support_item_number}
                        </div>
                      </td>
                      <td className='px-4 py-4 text-sm text-gray-500 text-center hidden md:table-cell'>
                        <div className='text-gray-500'>{fund?.unit}</div>
                      </td>
                      <td className='px-4 py-4 text-sm text-gray-500 text-center'>
                        <div className='text-gray-500'>
                          {fund?.unit === "H"
                            ? gethoursAndMins(fund?.total_hours, fund?.total_mint)
                            : fund?.quantity}
                        </div>
                      </td>
                      <td className='px-4 py-4 text-sm text-gray-500 text-center hidden lg:table-cell'>
                        <div className='text-gray-500'>
                          ${fund?.total_budget_amount}
                        </div>
                      </td>
                      <td className='px-4 py-4 text-sm text-gray-500 text-center hidden lg:table-cell'>
                        <div className='text-gray-500'>
                          {`$${
                            fund?.delivered_amount
                              ? parseFloat(fund?.delivered_amount).toFixed(2)
                              : 0
                          }`}
                        </div>
                      </td>
                      <td className='px-4 py-4 text-sm text-gray-500 text-center hidden xl:table-cell'>
                        <div className='text-gray-500' title="This column displays the quantity delivered for each line item.">
                          {fund?.unit === "H"
                            ? gethoursAndMins(
                              fund?.delivered_hours || 0,
                                fund?.delivered_minutes || 0
                              )
                            : fund?.delivered_quantity || 0}
                        </div>
                      </td>
                      <td className='px-4 py-4 text-sm text-gray-500 text-center hidden xl:table-cell'>
                        <div className='text-gray-500'>
                          {fund?.unit === "H"
                            ? gethoursAndMins(
                              fund?.remain_total_hours,
                                fund?.remain_total_mint
                              )
                            : fund?.remain_quantity ?? 0}
                        </div>
                      </td>
                      <td className='px-4 py-4 text-sm text-gray-500 text-center'>
                        <div className= {parseFloat(fund?.remain_amount ?? 0) <= 0 ? 'text-red-600' : 'text-gray-500'}>
                          ${parseFloat(fund?.remain_amount ?? 0).toFixed(2)}
                        </div>
                      </td>
                      <td className='px-4 py-4 text-sm text-gray-500 text-center'>
                        <div className='flex justify-center'>
                          <span
                            className='text-indigo-600 hover:text-indigo-900 cursor-pointer'
                            onClick={() => setServiceSupportItem(fund)}
                          >
                            <div className='icon-pencil-wrapper' title='Edit'>
                              <BiPencil className='icon-size' />
                            </div>
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  renderLoading !== LOADER_STATUS.NA &&
                  serviceSupportBudgetToMap.length === 0 && (
                    <tr>
                      <td
                        colSpan={10}
                        className='py-6 text-center text-red-600'
                      >
                        No Data found!
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className='bg-white py-4'>
        <PaginationComponent
          page={paginationObj.page}
          activeListLength={serviceSupportBudgetToMap}
          limit={SERVICE_SUPPORT_LIMIT}
          totalList={
            paginationObj.totalPages === 1
              ? serviceSupportBudgetToMap && serviceSupportBudgetToMap.length
              : paginationObj.total
          }
          handlePagination={(e) => {
            const obj = paginationObj;
            obj.page = e;
            setPaginationObj({ ...obj });
          }}
          totalPages={paginationObj.totalPages}
        />
      </div>
    </>
  );
};

export default ServiceSupportTable;
